import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { SPACE_PERMISSIONS_SETTINGS } from '@confluence/named-routes/entry-points/routes.ts';

const SpaceSettingsLandingPageRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-SpaceSettingsLandingPageRouteComponent" */ './SpaceSettingsLandingPageRouteComponent.tsx'
		),
});

export const SpaceSettingsLandingPageRoute: {
	({ params: { spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(
		{
			name,
			params: { spaceKey },
		}: {
			name: any;
			params: {
				spaceKey: any;
			};
		},
		isNav4Enabled: any,
	): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
			};
			pageState: {
				routeName: any;
				spaceKey: any;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: any;
		};
	};
} = ({ params: { spaceKey } }: RouteMatch): React.JSX.Element => {
	if (isCompanyHubSpaceKey(spaceKey)) {
		return (
			<Redirection name={SPACE_PERMISSIONS_SETTINGS.name} params={{ spaceKey, tab: 'users' }} />
		);
	}

	return <SpaceSettingsLandingPageRouteComponent spaceKey={spaceKey} />;
};

SpaceSettingsLandingPageRoute.NAVIGATION_PARAMS = (
	{
		name,
		params: { spaceKey },
	}: {
		name: any;
		params: {
			spaceKey: any;
		};
	},
	isNav4Enabled: any,
): {
	Screen: {
		screenEvent: {
			name: string;
			id: any;
		};
		pageState: {
			routeName: any;
			spaceKey: any;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: any;
	};
} => ({
	Screen: {
		screenEvent: { name: 'spaceSettingsLandingPage', id: spaceKey },
		pageState: { routeName: name, spaceKey },
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
